import React from 'react';
import { Flex, Tabs, Tab, TabList } from '@chakra-ui/react';
import ShareLinkControls from './ShareLinkControls';
import PDFViewerTab from './PDFViewerTab.js';
import MetadataTab from './MetadataTab.js';
import Chemical_data from './chemical_data.js';

const TabsContainer = ({
  tabIndex,
  setTabIndex,
  shareInfo,
  password,
  url,
  area,
  people_ID,
  place_ID,
  certName,
  tx,
  onPasswordUpdate,
  onCopyShareLink,
  onShowSendEmail,
  onCancelShare,
  onEnableSharing,
  onViewTransaction
}) => {
  return (
    <Tabs
      flexGrow={1}
      display="flex"
      flexDirection={'column'}
      index={tabIndex}
    >
      <Flex justify={'center'} mb={4} position="relative">
        <TabList color="#4F5E71">
          <Tab
            fontWeight="bold"
            _selected={{
              color: '#07B464',
              bg: '#EBFCF4',
              borderBottom: '#07B464 solid 2px',
            }}
            onClick={() => setTabIndex(0)}
          >
            PDF
          </Tab>
          <Tab
            fontWeight="bold"
            _selected={{
              color: '#07B464',
              bg: '#EBFCF4',
              borderBottom: '#07B464 solid 2px',
            }}
            onClick={() => setTabIndex(1)}
          >
            Metadata
          </Tab>
          <Tab
            fontWeight="bold"
            _selected={{
              color: '#07B464',
              bg: '#EBFCF4',
              borderBottom: '#07B464 solid 2px',
            }}
            onClick={() => setTabIndex(2)}
          >
            化學物質
          </Tab>
        </TabList>
        
        <ShareLinkControls
          shareInfo={shareInfo}
          password={password}
          onUpdatePassword={onPasswordUpdate}
          onCopyLink={onCopyShareLink}
          onShowSendEmail={onShowSendEmail}
          onCancelShare={onCancelShare}
          onEnableSharing={onEnableSharing}
        />
      </Flex>
      
      {url && tabIndex === 0 && (
        <PDFViewerTab url={url} />
      )}
      
      {url && tabIndex === 1 && (
        <MetadataTab
          area={area}
          people_ID={people_ID}
          place_ID={place_ID}
          certName={certName}
          tx={tx}
          onViewTransaction={onViewTransaction}
        />
      )}
      
      {url && tabIndex === 2 && (
        <Chemical_data show={false} certName={certName} />
      )}
    </Tabs>
  );
};

export default TabsContainer;
